import { Dialog, DialogTitle, DialogContent, DialogActions, Stack, Button } from '@mui/material';
import { RHFTextField } from 'src/components/hook-form';
import LoadingButton from '@mui/lab/LoadingButton';

type Props = {
  hook: any;
};

export default function CommentDialog({ hook }: Props) {
  return (
    <Dialog maxWidth="sm" fullWidth open={hook.openComment} onClose={hook.onCloseComment}>
      <DialogTitle>Motivo da Edição</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <RHFTextField
            name="editComment"
            label="Digite o motivo da edição:"
            multiline
            rows={4}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={hook.onCloseComment} color="inherit">
          Cancelar
        </Button>
        <LoadingButton onClick={hook.onSubmit} variant="contained" loading={hook.isSubmitting}>
          Confirmar Edição
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
